/* VSUAL — Rail horizontal
   Las flechas mueven el rail una "página" completa: tantas cards como haya a
   la vista, no una sola. Mover de a una obliga a diez clics para recorrer diez
   productos; mover de a página recorre la colección en tres.

   El paso se mide del DOM en vez de leerlo de un ajuste, así sigue siendo
   correcto cuando cambia el ancho de la ventana o el editor recarga la sección
   con otro número de cards.

   Se re-ejecuta en el editor de temas, donde las secciones se recargan sin
   recargar la página. Por eso todo el bind es idempotente. */
(function () {
  'use strict';

  function initRail(rail) {
    if (rail.dataset.vsualBound === 'true') return;
    rail.dataset.vsualBound = 'true';

    var section = rail.closest('.shopify-section') || document;
    var prev = section.querySelector('[data-vsual-rail-prev]');
    var next = section.querySelector('[data-vsual-rail-next]');

    function page() {
      var first = rail.firstElementChild;
      if (!first) return rail.clientWidth;
      var w = first.getBoundingClientRect().width;
      var styles = getComputedStyle(rail);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      var step = w + gap;
      // cuántas entran enteras en lo visible, al menos una
      var visible = Math.max(1, Math.floor((rail.clientWidth + gap) / step));
      return step * visible;
    }

    function syncArrows() {
      if (!prev || !next) return;
      // 2px de tolerancia: el scroll fraccionario nunca cae en el entero exacto
      var max = rail.scrollWidth - rail.clientWidth;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max - 2;
    }

    // scroll-snap-type: x mandatory cancela el scroll suave programático: el
    // navegador vuelve a encajar en cada cuadro y la animación no avanza, así
    // que la flecha no hacía nada. Se suelta el encaje mientras dura el
    // movimiento y se devuelve al terminar. Como el paso es una página entera
    // y se arranca desde una posición ya encajada, el destino también lo es.
    var restore, fallback;
    var quietoMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

    function go(delta) {
      var previo = rail.style.scrollSnapType;
      var desde = rail.scrollLeft;
      var destino = Math.max(0, Math.min(desde + delta, rail.scrollWidth - rail.clientWidth));

      function devolver() {
        rail.style.scrollSnapType = previo || '';
        syncArrows();
      }

      if (quietoMotion && quietoMotion.matches) {
        rail.scrollLeft = destino;
        syncArrows();
        return;
      }

      rail.style.scrollSnapType = 'none';
      rail.scrollBy({ left: delta, behavior: 'smooth' });

      // Hay entornos donde el scroll suave no se anima: la app en modo ahorro,
      // el navegador con animaciones apagadas, una pestaña sin componer. Si a
      // los 250ms no se movió ni un píxel, se salta de una. Vale más un control
      // que siempre responde que una transición que a veces no ocurre.
      clearTimeout(fallback);
      fallback = setTimeout(function () {
        if (rail.scrollLeft === desde && desde !== destino) {
          rail.scrollLeft = destino;
          devolver();
        }
      }, 250);

      clearTimeout(restore);
      if ('onscrollend' in window) {
        rail.addEventListener('scrollend', devolver, { once: true });
        // por si el navegador no llega a emitirlo
        restore = setTimeout(devolver, 1200);
      } else {
        restore = setTimeout(devolver, 600);
      }
    }

    if (prev) prev.addEventListener('click', function () { go(-page()); });
    if (next) next.addEventListener('click', function () { go(page()); });

    var ticking = false;
    rail.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        syncArrows();
        ticking = false;
      });
    }, { passive: true });

    if (window.ResizeObserver) {
      new ResizeObserver(syncArrows).observe(rail);
    } else {
      window.addEventListener('resize', syncArrows);
    }

    // las fotos van en lazy: hasta que no cargan, scrollWidth miente
    rail.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', syncArrows, { once: true });
    });

    syncArrows();
  }

  function initAll() {
    document.querySelectorAll('[data-vsual-rail]').forEach(initRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
